import { useEffect, useRef } from 'react';

import * as PickPairStore from '@Stores/PickPair';
import * as HeaderStore from '@Stores/Header';
import usePage from '@Queries/usePage';
import LayoutMain from '@Layouts/LayoutMain';
import PageTopBar from '@Components/PageTopBar';
import Page from '@Components/Page';
import AnimatedBanner from './elems/AnimatedBanner';
import Text from './elems/Text';
import Video from './elems/Video';
import CollectionBenefits from './elems/CollectionBenefits';
import Catalog from './elems/Catalog';
import Benefits from './elems/Benefits';
import Set from './elems/Set';
import styles from './PagePickAndPair.module.css';

import type { FC } from 'react';
import type { PickAndPairData } from './typings';

const PagePickAndPair: FC = () => {
  const { data: page } = usePage<PickAndPairData>();
  const { breadcrumbs, products, constructor } = page;
  const { contentHeight } = HeaderStore.useSizes();
  const constructorRef = useRef<HTMLDivElement>(null);

  const handleClickToScroll = () => {
    if (constructorRef.current) {
      const rect = constructorRef.current.getBoundingClientRect();
      const top = window.scrollY + rect.top - contentHeight;

      window.scrollTo({ top, behavior: 'instant' });
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  useEffect(() => {
    PickPairStore.init(constructor.set);

    return () => PickPairStore.clear();
  }, [constructor.set]);

  return (
    <LayoutMain>
      <Page>
        <PageTopBar breadcrumbs={breadcrumbs} />
        <div>
          <div className={styles.overflowWrapper}>
            <AnimatedBanner />
            <Text onClick={handleClickToScroll} />
            <Video />
          </div>
          <CollectionBenefits />
          {constructor && (
            <Set className={styles.set} constructor={constructor} ref={constructorRef} />
          )}
          <Catalog className={styles.catalog} products={products} />
          <Benefits />
        </div>
      </Page>
    </LayoutMain>
  );
};

export default PagePickAndPair;
